export default __webpack_public_path__ + "static/media/shape-3.63e593ae.svg";